



























































































































































































































































import Component, { mixins } from 'vue-class-component';

import Breadcrumb from '@/components/Pages/Breadcrumbs/Hikari.vue';
import Heading2 from '@/components/Atoms/Heading/Heading2.vue';
import FormArea from '@/components/Pages/HikariEstimate/ApplyForm.vue';
import LeadSection from '@/components/Templates/LeadSection.vue';
import Question from '@/components/Templates/Question.vue';
import EntryType from '@/components/Pages/HikariEstimate/EntryType.vue';
import ApplyType from '@/components/Pages/HikariEstimate/ApplyType.vue';
import Vas from '@/components/Pages/HikariEstimate/Vas.vue';
import PcSideBar from '@/components/Pages/HikariEstimate/PcSideBar.vue';
import SpSideBar from '@/components/Pages/HikariEstimate/SpSideBar.vue';
import BuildingType from '@/components/Pages/HikariEstimate/BuildingType.vue';
import PhoneLead from '@/components/Pages/HikariEstimate/PhoneLead.vue';
import PhoneContents from '@/components/Pages/HikariEstimate/PhoneContents.vue';
import StaticIpComponent from '@/components/Pages/HikariEstimate/StaticIp.vue';
import FooterComponent from '@/components/Templates/Footer.vue';

import CurrentRental10gWifiRouter from '@/components/Pages/HikariEstimate/CurrentRental10gWifiRouter.vue';
import CurrentRentalEquipment from '@/components/Pages/HikariEstimate/CurrentRentalEquipment.vue';
import CurrentRentalNttWestWifiRouter from '@/components/Pages/HikariEstimate/CurrentRentalNttWestWifiRouter.vue';
import CurrentRentalWifiRouter from '@/components/Pages/HikariEstimate/CurrentRentalWifiRouter.vue';
import RentalWifiRouter from '@/components/Pages/HikariEstimate/RentalWifiRouter.vue';
import Rental10gWifiRouter from '@/components/Pages/HikariEstimate/Rental10gWifiRouter.vue';

import { HikariConfig } from '@/data/hikariConfig';
import { VasConfig } from '@/data/vasConfig';

import TextLink from '@/components/Atoms/Link/TextLink.vue';
import UrlMixin from '@/mixins/url';

import jsonFile from '@/../config/hikari.json';

const hikariConfig = new HikariConfig(jsonFile);
const vasConfig = new VasConfig();

@Component({
  components: {
    FooterComponent,
    TextLink,
    Question,
    Breadcrumb,
    Heading2,
    FormArea,
    LeadSection,
    EntryType,
    Vas,
    PcSideBar,
    SpSideBar,
    BuildingType,
    ApplyType,
    PhoneLead,
    PhoneContents,
    StaticIpComponent,
    CurrentRental10gWifiRouter,
    CurrentRentalEquipment,
    CurrentRentalNttWestWifiRouter,
    CurrentRentalWifiRouter,
    RentalWifiRouter,
    Rental10gWifiRouter
  },
})
export default class Hikari extends mixins(UrlMixin) {
  private config: HikariConfig = hikariConfig;
  private vas: VasConfig = vasConfig;
  private _headlinks: HTMLLinkElement[] = [];
  // 画面が表示された時
  mounted() {
    document.body.classList.add('hikari_estimate') // bodyにクラスを追加
    //M+1フォント読み込み
    this._headlinks = []
    const fontLinks = [
      { rel: 'preconnect', href: 'https://fonts.googleapis.com', dataset: 'Mplus1-GoogleApi-preconnect'},
      { rel: 'preconnect', href: 'https://fonts.gstatic.com', dataset: 'Mplus1-Gstatic-preconnect'},
      { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=M+PLUS+1:wght@100..900&display=swap', dataset: 'Mplus1-stylesheet'},
    ]
    fontLinks.forEach(info => {
      const link = document.createElement('link')
      Object.entries(info).forEach(([k, v]) => {
        if (k === 'dataset') link.dataset.vueComponent = v
        else link.setAttribute(k, v)
      });
      document.head.appendChild(link)
      this._headlinks.push(link)
    })
  }

  // 画面が非表示になった時
  beforeDestroy() {
    document.body.classList.remove('hikari_estimate') // クラスを削除
    //M+1フォント削除
    if (this._headlinks && this._headlinks.length)
      this._headlinks.forEach(link => link.remove())
    this._headlinks = []
  }

  // ご利用中の光回線はありますか
  get entryType() {
    return this.$store.getters['hikari/entryType'];
  }
  // 申込タイプ
  get applyType() {
    return this.$store.getters['hikari/applyType'];
  }
  // 現在ご利用中の回線タイプ
  get currentUsageType() {
    return this.$store.getters['hikari/currentUsageType'];
  }
  // basic ace | none
  get phonePlan(): string {
    return this.$store.getters['hikari/phonePlan'];
  }
  // ご利用中の回線が新規である
  get checkNewType(): boolean {
    return this.entryType === 'new';
  }

  // ご利用中の回線が光回線再利用である
  get checkReuseType(): boolean {
    return this.entryType === 'reuse';
  }
  // ご利用中の回線が転用、事変である
  get checkOtherOrFletsType(): boolean {
    return ['other', 'flets'].includes(this.entryType);
  }
  // 電話あり判定
  get checkUsePhone(): boolean {
    return ['basic', 'ace'].includes(this.phonePlan);
  }
  // 電話なし判定
  get checkNoneUsePhone(): boolean {
    return this.phonePlan === 'none';
  }

  // 現在、NTT東日本の無線LAN付きルーターをレンタルしていますか。
  get isShowCurrentRentalNttWestWifiRouter(): boolean {
    return this.checkOtherOrFletsType && this.currentUsageType == '1g' && this.applyType == '1g' && this.checkNoneUsePhone;
  }

  // 10G対応の無線LANルーターをレンタルしますか。
  get isShowRental10gWifiRouter(): boolean {
    if (this.checkNewType || this.checkReuseType) {
      return this.applyType == '10g' && this.checkNoneUsePhone
    } else if (this.checkOtherOrFletsType) {
      return this.currentUsageType == '1g' && this.applyType == '10g' && this.checkNoneUsePhone;
    } else {
      return false;
    }
  }

  // 無線LAN機能付きのルーターをレンタルしますか。
  get isShowRentalWifiRouter(): boolean {
    if (this.checkNewType || this.checkReuseType) {
      return this.applyType == '10g' && this.checkUsePhone
    } else if (this.checkOtherOrFletsType) {
      return this.currentUsageType == '1g' && this.applyType == '10g' && this.checkUsePhone;
    } else {
      return false;
    }
  }

  // 現在、無線LAN機能付きのルーターをレンタルしていますか。
  get isShowCurrentRentalWifiRouter(): boolean {
    return this.checkOtherOrFletsType && this.currentUsageType == '10g' && this.applyType == '10g' && this.checkUsePhone;
  }

  // 現在、10G対応の無線LANルーターをレンタルしていますか。
  get isShowCurrentRental10gWifiRouter(): boolean {
    return this.checkOtherOrFletsType && this.currentUsageType == '10g' && this.applyType == '10g' && this.checkNoneUsePhone;
  }

  // 現在レンタルしている機器について教えてください。
  get isShowCurrentRentalEquipment(): boolean {
    return this.checkOtherOrFletsType && this.currentUsageType == '1g' && this.applyType == '1g' && this.checkUsePhone;
  }
}
